
import { ISelectItem } from "winfakt-vue-components";
import Vue from "vue";

export default Vue.extend({
	props: {
		// eslint-disable-next-line vue/require-prop-types
		value: {
		},
		label: {
			type: String,
			default: "Type"
		},
		up: Boolean,
		fancy: Boolean,
		useUndefined: Boolean
	},
	computed: {
		items():ISelectItem<boolean | null | undefined>[]{
			return [
				{
					text: "Klanten en intern",
					value: this.useUndefined ? undefined : null
				},
				{
					text: "Klanten",
					value: false
				},
				{
					text: "Intern",
					value: true
				},
			];
		},
	},
	methods: {
		setValue(value:boolean | null){
			this.$emit("input", value);
		}
	}
});
